






























































































import { Component, Mixins, Prop } from "vue-property-decorator";
import { DataModules } from "@/store/modules/data";
import { IImportSource, IImportSourceCredentials } from "@/models/imports";
import { mapState } from "vuex";
import RequestPromises from "@/mixins/requestPromises";
import { IModalComponent } from "@/models/modal";
import _ from "@/boot/lodash";

@Component({
  computed: {
    ...mapState({
      credentials(state, getters) {
        return getters[`data/listArray`]({
          scope: this.dataScope,
          storeModule: DataModules.IMPORTS
        });
      }
    })
  }
})
export default class SourceCredentialsSelect extends Mixins(RequestPromises) {
  // Props
  @Prop({ required: true })
  public value!: IImportSourceCredentials["id"] | null;

  @Prop({ required: true })
  public source!: IImportSource;

  @Prop({ required: true })
  public sourceId!: IImportSource["id"];

  @Prop({ default: false })
  public isDisabled!: boolean;

  // Data
  public readonly dataScope = `$${this.sourceId}_credentials`;
  public isLoading = true;
  public credentials!: IImportSourceCredentials[];

  // Life-cycle methods

  public created() {
    this.getSourceCredentials();
  }

  public beforeDestroy() {
    this.binSourceCredentials();
  }

  // Computed

  public get isSkeleton() {
    return this.isLoading || !this.credentials.length;
  }

  public get selectorItems() {
    return this.isSkeleton
      ? this.$_.range(3).map(() => ({ leftLabel: "" }))
      : this.credentials;
  }

  public get selectedCredentials(): IImportSourceCredentials["id"] | null {
    return this.value;
  }

  public set selectedCredentials(value) {
    this.$emit("input", value);
  }

  // Methods

  public async getSourceCredentials(
    { ignoreStored } = { ignoreStored: false }
  ) {
    try {
      await this.$store.dispatch(
        `data/${DataModules.IMPORTS}/listSourceCredentials`,
        {
          sourceId: this.sourceId,
          payload: {
            ignoreStored,
            scope: this.dataScope,
            vm: this
          }
        }
      );
    } catch (error) {
      this.$store.dispatch("api/handleError", error);
    } finally {
      this.isLoading = false;
    }
  }

  public async binSourceCredentials(): Promise<void> {
    try {
      await this.$store.dispatch("data/binList", {
        scope: this.dataScope,
        storeModule: DataModules.IMPORTS,
        vm: this
      });
    } catch (error) {
      this.$store.dispatch("api/handleError", error);
    }
  }

  public editCredentials(
    credentials: IImportSourceCredentials
  ): Promise<IModalComponent> {
    return this.addEditCredentials({
      credentialsId: credentials.id,
      ..._.pick(credentials, [
        "url",
        "username",
        "tax_setting",
        "admin_dashboard_url"
      ])
    });
  }

  public async deleteCredentials(credentials: IImportSourceCredentials) {
    const confirm = await this.$store.dispatch("ui/open/confirmModal", {
      config: {
        props: {
          autoClose: false,
          title: this.$t("_action.delete_credentials"),
          confirmButtonText: this.$t("_action.delete"),
          message: this.$t(`_sentence.imports.confirm_credentials_delete`, {
            source: this.source.name,
            hostname: credentials.hostname
          })
        },
        events: {
          confirmed: async () => {
            try {
              await this.$store.dispatch(
                `data/${DataModules.IMPORTS}/deleteSourceCredentials`,
                {
                  sourceId: this.sourceId,
                  credentialsId: credentials.id
                }
              );
              this.getSourceCredentials({ ignoreStored: true });
              this.$buefy.toast.open({
                message: this.$t("_.credentials_deleted") as string
              });
            } catch (error) {
              this.$store.dispatch("api/handleError", error);
            } finally {
              confirm.close();
            }
          }
        }
      }
    });
  }

  public addEditCredentials(props = {}): Promise<IModalComponent> {
    return this.$store.dispatch("ui/open/windowModal", {
      config: {
        component: () =>
          import(
            "@/components/app/admin/imports/addEditSourceCredentialsModal.vue"
          ),
        canCancel: ["button"],
        parent: this,
        width: 540,
        props: {
          source: this.source,
          sourceId: this.sourceId,
          ...props
        },
        events: {
          success: () => this.getSourceCredentials({ ignoreStored: true })
        }
      }
    });
  }
}
